import { FC } from 'react';

import PayrollPayment from '../../../../../components/CardPlanWithImage/CardPlanAmountsSection/PayrollPayment';
import RecurrentPayment from '../../../../../components/CardPlanWithImage/CardPlanAmountsSection/RecurrentPayment';
import SinglePayment from '../../../../../components/CardPlanWithImage/CardPlanAmountsSection/SinglePayment';
import {
  PAYMENT_TYPE_ID_PAYROLL,
  PAYMENT_TYPE_ID_RECURRENT,
  PAYMENT_TYPE_ID_SINGLE_PAYMENT,
} from '../../../../../constants/constants';

type PaymentsFrequenciesItem = {
  price: string;
  frequency: string;
  order: number;
  paymentFrequencyName?: string;
};

type Props = {
  item?: {
    name?: string;
    description?: string;
    price?: string;
    categories?: Array<any>;
    id?: number;
    paymentsFrequencies?: Array<PaymentsFrequenciesItem>;
    paymentTypeId?: number;
  };
  detailModal?: boolean;
};

const CardPlanAmountsSection: FC<Props> = ({ item = {} }) => {
  const getAmountComponent = () => {
    switch (item.paymentTypeId) {
      case PAYMENT_TYPE_ID_PAYROLL:
        return <PayrollPayment item={item} />;
      case PAYMENT_TYPE_ID_SINGLE_PAYMENT:
        return <SinglePayment item={item} showInfo={false} />;
      case PAYMENT_TYPE_ID_RECURRENT:
        return <RecurrentPayment item={item} selectWithColorPrimary />;
      default:
        return null;
    }
  };

  return getAmountComponent();
};

export default CardPlanAmountsSection;
